export default "__VITE_ASSET__TZTu9w2a__"